import moment from 'moment-timezone';

const PIGRECO_TIME_ZONE = 'Europe/Rome';

// Pigreco returns date_end as a UTC date-time without a timezone suffix.
// Parse it explicitly as UTC before presenting it in the Koala timezone.
export const parsePigrecoUtcDateTime = (value) => {
    if (!value) return null;

    const parsed = moment.utc(value);
    return parsed.isValid() ? parsed.tz(PIGRECO_TIME_ZONE) : null;
};

export const formatPigrecoCompletionDate = (value) => {
    const parsed = parsePigrecoUtcDateTime(value);
    return parsed ? parsed.format('DD/MM/YYYY HH:mm:ss') : '-';
};
